import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useFeatureIsOn, useGrowthBook } from '@growthbook/growthbook-react'

const useCartVersionChecker = () => {
  const [cartVersion, setCartVersion] = useState(null)
  const isCartV2Enabled = useFeatureIsOn('cart-v2')
  const { cart } = useSelector(state => state.cart)
  const { order } = useSelector(state => state.checkout)
  const hasV1StoreCart = (order?.lineItems?.some(item => item?.isStoreSku) ?? false) && !order?.eCart?.id
  const v1CartSize = cart?.cartItems?.length ?? 0
  const hasV1Cart = v1CartSize > 0 || hasV1StoreCart
  const growthbook = useGrowthBook()
  const isGrowthbookReady = growthbook?.ready

  useEffect(() => {
    if (isGrowthbookReady) {
      if (!isCartV2Enabled) {
        setCartVersion('v1')
      } else if (hasV1Cart) {
        setCartVersion('v1')
      } else {
        setCartVersion('v2')
      }
    }
  }, [hasV1Cart, isCartV2Enabled, isGrowthbookReady])

  return isGrowthbookReady ? cartVersion : null
}

export default useCartVersionChecker
